export const PLAYBOOK_STATUS_ACTIVE = "Active";
export const PLAYBOOK_STATUS_DRAFT = "Draft";
